import Paper from "@mui/material/Paper";
import { useCallback, useState } from "react";
import RevokeButton from "../buttons/RevokeButton";
import { useMediaQuery } from "@mui/material";
import theme from "../../../../../theme";
import {
  OrderDirection,
  Role,
  Role_OrderBy,
} from "../../../../../apis/__generated__/graphql";
import { useRoles } from "../../../../../providers/ContractProvider";
import { useQuery } from "@apollo/client";
import { GET_ROLES } from "../../../../../libraries/queries/roles";
import {
  DataGridPro,
  DataGridProProps,
  GridColDef,
  GridSortModel,
} from "@mui/x-data-grid-pro";

export interface OperatorTableProps {}

export default function OperatorTable() {
  const [selectedRow, setSelectedRow] = useState<Role | undefined>(undefined);
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [sortModel, setSortModel] = useState<GridSortModel>();

  const [paginationModel, setPaginationModel] = useState({
    pageSize: 10,
    page: 0,
  });
  const { OPERATOR_ROLE } = useRoles();

  const { data, refetch, loading } = useQuery(GET_ROLES, {
    variables: {
      first: paginationModel.pageSize,
      skip: paginationModel.pageSize * paginationModel.page,
      where: {
        role: OPERATOR_ROLE,
      },
      orderDirection:
        sortModel?.[0]?.sort === "asc"
          ? OrderDirection.Asc
          : OrderDirection.Desc,
      orderBy: sortModel?.[0]?.field as Role_OrderBy,
    },
    skip: !OPERATOR_ROLE,
  });

  const operators = data?.roles || [];

  const onPaginationModelChange = useCallback<
    NonNullable<DataGridProProps["onPaginationModelChange"]>
  >((model) => {
    setPaginationModel(model);
  }, []);

  const onSortModelChange = useCallback<
    NonNullable<DataGridProProps["onSortModelChange"]>
  >(
    (model) => {
      setSortModel(model);
    },
    [setSortModel]
  );

  const columns: GridColDef[] = [
    {
      field: "account",
      headerName: "Address",
      flex: 1,
      valueGetter: ({ value }) => {
        return isSmallScreen
          ? value.slice(0, 10) + "…" + value.slice(-10)
          : value;
      },
    },
    {
      field: "actions",
      type: "actions",
      getActions: ({ row }) => [
        <RevokeButton
          key="Revoke"
          onSelectedRow={() => setSelectedRow(row)}
          onUnselectedRow={() => setSelectedRow(undefined)}
          row={selectedRow}
          refetch={refetch}
        />,
      ],
      width: 100,
    },
  ];

  return (
    <Paper>
      <DataGridPro
        sx={{
          ".MuiTablePagination-displayedRows": {
            display: "none",
          },
        }}
        pagination
        rows={operators}
        columns={columns}
        paginationMode="server"
        sortingMode="server"
        filterMode="server"
        rowCount={
          operators.length === 10
            ? paginationModel.pageSize * (paginationModel.page + 1) + 1
            : paginationModel.pageSize * (paginationModel.page + 1)
        }
        disableRowSelectionOnClick
        getRowId={(row) => row.id}
        loading={loading}
        autoHeight
        disableColumnMenu={true}
        paginationModel={paginationModel}
        onPaginationModelChange={onPaginationModelChange}
        onSortModelChange={onSortModelChange}
      />
    </Paper>
  );
}
